module.exports = __webpack_public_path__ + "static/media/LOMEGG_MENU-normal.53a23e51.png";